import { ViewModel, View } from "binder"
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { IbanSelectorSelectorViewModel } from "src/erp/arap/rawData/ibanSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider, PaymentInfo } from "../IGateway";
import { IbanGatewayView } from "./ibanGateway-view"

export class IbanGatewayViewModel extends ViewModel implements IGateway {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    get title(): string {
        return translate("ibanGateway-viewModel.Iban", {});
    }

    GetDefaultView(): View<ViewModel> {
        return new IbanGatewayView();
    }

    public getTypeId(): string {
        return "VM-73D9175F-8E12-4E92-A64A-A18B04F7B595"
    }

    public set accountSelector(v: IbanSelectorSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): IbanSelectorSelectorViewModel { return this._accountSelector; } private _accountSelector: IbanSelectorSelectorViewModel;
    public set destinationIBanNumber(v: string) { this._destinationIBanNumber = v; } public get destinationIBanNumber(): string { return this._destinationIBanNumber; } private _destinationIBanNumber: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode; } private _traceCode: string;

    initialLoad(paymentInfo:PaymentInfo): void {
        this.accountSelector = new IbanSelectorSelectorViewModel(this);
        this.destinationIBanNumber = paymentInfo.Iban;
    }

    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateIbanTransferPayment', {
            ProcessId: paymentInfo.processId,
            Attachments: paymentInfo.attachments.map(p => {
                return {
                    Data: p.content,
                    Name: p.name
                }
            }),
            SourceGatewayId: this.accountSelector.selectedItem.id,
            DestinationIbanNumber: this.destinationIBanNumber,
            TraceCode: this.traceCode
        });
    }

    validate(): string[] {
        let result = [];
        if (this.accountSelector.selectedItem == null) {
            result.push("لطفا شماره حساب مبدا را انتخاب کنید.");
        }
        if (this.destinationIBanNumber == null) {
            result.push("لطفا شماره شبا مقصد را وارد کنید.");
        }
        if (stringIsNullOrEmpty(this.traceCode)) {
            result.push("لطفا کد پیگیری را وارد کنید.");
        }
        return result;
    }

}
